/*       */

import { gql } from '@apollo/client';

export default gql`
    query executeScriptViewerMutation($id: ID!, $input: JSON) {
        result: getPrintTemplateData(id: $id, input: $input)
    }
`;
